import { Category } from "./types";

export const resToCategory = (res: any): Category => ({
  id: res.id,
  name: res.name ?? "",
});
